import React, { useEffect, useRef, useState } from 'react';
import { LocalizationProvider, DatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { getHtmlElUID } from '../../../utils/helpers';
import moment from 'moment';

const DateTimePickerRow = ({ name, inputId, onSelectDate, hasError, value, disabled = false, ariaLabel }) => {
  const [selectedDate, handleDateChange] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, togglePicker] = useState(false);
  const dateRef = useRef();

  useEffect(() => {
    if (value && !selectedDate) {
      handleDateChange(moment(value));
    }
  }, [value]);

  useEffect(() => {
    onSelectDate(moment(selectedDate).valueOf());
    togglePicker(false);
  }, [selectedDate]);

  useEffect(() => {
    if (!isLoaded && value && selectedDate) {
      setIsLoaded(true);
    }
    if (isLoaded && value && selectedDate) {
      dateRef.current?.focus();
    }
  }, [selectedDate]);

  const descUID = getHtmlElUID('app-dt-picker-desc');

  useEffect(() => {
    const onGlobalClick = (e) => {
      const isClickedWithinTheDilaog = e.target.closest('.MuiPickersPopper-root');
      const isToggleButton = e.target.classList.contains('fa-calendar-alt');
      isToggleButton || isClickedWithinTheDilaog ? void 0 : togglePicker(false);
    };
    document.addEventListener('click', onGlobalClick);
    return () => {
      document.removeEventListener('click', onGlobalClick);
    }
  });

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div aria-describedby={descUID} className={`date-time-wrapper ${hasError ? 'date-time-border-error' : ''}`}>
        <span id={descUID} className="hide-by-pos"></span>
        <DatePicker
          className={'date-picker-wrapper'}
          disablePast={!disabled}
          slots={{
            inputAdornment: () => null,
          }}
          slotProps={{
            textField: {
              ref: dateRef,
              placeholder: 'mm/dd/yyyy',
              className: 'date-picker',
              name,
              id: inputId,
            },
            openPickerButton: {
              'aria-label': ariaLabel,
              hidden: true,
            },
            toolbar: {
              hidden: true,
            },
          }}
          open={isOpen}
          onChange={(date) => handleDateChange(date)}
          disabled={disabled}
          format="MM/DD/YYYY"
          value={moment(selectedDate)}
        />
        <i className={`far fa-calendar-alt pointer calendar-button calendar-button-${name}`} onClick={() => togglePicker(!isOpen)}></i>
        <span className="at">at</span>
        <MobileTimePicker
          disabled={disabled}
          slotProps={{
            textField: {
              className: 'time-picker'
            }
          }}
          value={moment(selectedDate)}
          onChange={(time) => handleDateChange(time)}
        />
        <span className="est">ET</span>
      </div>
    </LocalizationProvider>
  );
};

export default DateTimePickerRow;
